$('#client-carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
	navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
	autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive: {
        0: {
            items: 2
        },
        600: {
            items: 4
        },
        1000: {
            items: 5
        }
    }
})
$('.owl-carousel').find('.owl-nav').removeClass('disabled');
$('.owl-carousel').on('changed.owl.carousel', function(event) {
	$(this).find('.owl-nav').removeClass('disabled');
});

$('#client-carousel-1').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
	autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
	navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
    responsive: {
        0: {
            items: 2
        },
        600: {
            items: 4
        },
        1000: {
            items: 5
        }
    }
})

$('.tjr-single-select-category-img-carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    mouseDrag: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

$('#recent-projects').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
})

$('#latest-news').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
})

var sync1 = $("#sync1");
var sync2 = $("#sync2");
var slidesPerPage = 4; //globaly define number of elements per page
var syncedSecondary = true;

sync1.owlCarousel({
	items: 1,
	slideSpeed: 2000,
	nav: false,
	autoplay: true,
	dots: false,
	loop: true,
	responsiveRefreshRate: 200,
	navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
}).on('changed.owl.carousel', syncPosition);

sync2
	.on('initialized.owl.carousel', function() {
		sync2.find(".owl-item").eq(0).addClass("current");
	})
	.owlCarousel({
		items: slidesPerPage,
		dots: false,
		nav: false,
		smartSpeed: 200,
		slideSpeed: 500,
		slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
		responsiveRefreshRate: 100
	}).on('changed.owl.carousel', syncPosition2);

function syncPosition(el) {
	//if you set loop to false, you have to restore this next line
	//var current = el.item.index;

	//if you disable loop you have to comment this block
	var count = el.item.count - 1;
	var current = Math.round(el.item.index - (el.item.count / 2) - .5);

	if (current < 0) {
		current = count;
	}
	if (current > count) {
		current = 0;
	}

	//end block

	sync2
		.find(".owl-item")
		.removeClass("current")
		.eq(current)
		.addClass("current");
	var onscreen = sync2.find('.owl-item.active').length - 1;
	var start = sync2.find('.owl-item.active').first().index();
	var end = sync2.find('.owl-item.active').last().index();

	if (current > end) {
		sync2.data('owl.carousel').to(current, 100, true);
	}
	if (current < start) {
		sync2.data('owl.carousel').to(current - onscreen, 100, true);
	}
}

function syncPosition2(el) {
	if (syncedSecondary) {
		var number = el.item.index;
		sync1.data('owl.carousel').to(number, 100, true);
	}
}

sync2.on("click", ".owl-item", function(e) {
	e.preventDefault();
	var number = $(this).index();
	sync1.data('owl.carousel').to(number, 300, true);
});


$(document).on('click', '.number-spinner button', function() {
    var btn = $(this),
        oldValue = btn.closest('.number-spinner').find('input').val().trim(),
        newVal = 0;

    if (btn.attr('data-dir') == 'up') {
        newVal = parseInt(oldValue) + 1;
    } else {
        if (oldValue > 1) {
            newVal = parseInt(oldValue) - 1;
        } else {
            newVal = 1;
        }
    }
    btn.closest('.number-spinner').find('input').val(newVal);
});

$(document).ready(function() {
	$(".read-more-btn").on( "click", function() {
		if($(this).html().trim()=="Expand to read more"){
			$("#more_"+$(this).data("id")).show();
			$("#less_"+$(this).data("id")).hide();
			$(this).html("Read less");
		} else {
			$("#more_"+$(this).data("id")).hide();
			$("#less_"+$(this).data("id")).show();
			$(this).html("Expand to read more");
		}
	});

	
	$( ".quick-contact-button-wrap" ).click( function() {
	   $( ".toggle-form-wrap" ).toggle( 'slow' );
	   $(this).toggleClass('hide');
   });

	$( ".quick-contatc-label-wrap" ).click( function() {
		$( ".quick-contatc-label-wrap" ).parents(".toggle-form-wrap").toggle( 'slow' );
		$(".quick-contact-button-wrap").removeClass('hide');
   });
   
   //var submitUrl = "/admin/script_tags.json?src=http://127.0.0.1/wwt-wp/tjr/php/request.php";
   //var submitUrl = "/admin/script_tags.json?src=http://phpdev3.worldwebdev.in/request.php";
   var submitUrl = "https://tjr-cs-mailer.hosted.tanist.co.uk/request.php";
   

   $( "#quick-contact-form-btn" ).click( function() {
	   if($('#quick-contact-form')[0].checkValidity()) {

			var datastring = $("#quick-contact-form").serialize();
			
			$( "#imps" ).load( submitUrl, datastring );
			$("#quick-contact-form-msg").removeClass("hide");
			$("#quick-contact-form").trigger("reset");
			
			
			/*
			$.ajax({
				type: "POST",
				url: submitUrl,
				data: datastring,
				dataType: "json",
				success: function(data) {
					//var obj = jQuery.parseJSON(data); if the dataType is not specified as json uncomment this
					// do what ever you want with the server response
					alert("Thank you for email");
					$("#quick-contact-form").reset();
				},
				error: function() {
					alert('error handling here');
				}
			});*/
		}
	});
	
	$( "#quick-contact-page-form-btn" ).click( function() {
	   if($('#quick-contact-page-form')[0].checkValidity()) {

			var datastring = $("#quick-contact-page-form").serialize();
			
			//$( "#imps" ).load( submitUrl, datastring );			
			$("#quick-contact-page-form-msg").removeClass("hide");
			$("#quick-contact-page-form").trigger("reset");
			
			
			$.ajax({
				type: "POST",
				url: submitUrl,
				data: datastring,
				dataType: "json",
				success: function(data) {
					//var obj = jQuery.parseJSON(data); if the dataType is not specified as json uncomment this
					// do what ever you want with the server response
					alert("Thank you for email");
					$("#quick-contact-form").reset();
				},
				error: function() {
					alert('error handling here');
				}
			});
		}
	});	
	
	$(".search-bar-icon").on( "click", function() {
		$(".search-input-box").toggle();
	});
});


function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}
function AjaxAddToCart(variant_id, quantity) {
  	$.ajax({
      type: "post",
      url: "/cart/add.js",
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      beforeSend: function() {
		  
      //showLoading();
      },
      success: function() {
		getAndUpdateCart();
	  },
	  error: function(xhr){
		  var resp = JSON.parse(xhr.responseText);
			alert(resp.description);
	 }
	  });
}

function getAndUpdateCart() {
	$.ajax({
      type: "get",
      url: "/cart.js",
	  dataType: 'json',
	  cache: false,
	  success: function(cart) {		  
		  if(cart.item_count > 0) {
			  $(".cart-count").text(" Your basket (" + cart.item_count + ")");
		  }
		  if(cart.original_total_price*0.01 > 0 && cart.original_total_price*0.01 < 600) {			  
			  var diffT = parseFloat(600 - (cart.original_total_price*0.01));			  
			  $("#spend-another-top-div-amt").html(diffT);
			  $(".spend-another-top-div").removeClass("d-none");
		  } else {
			  $(".spend-another-top-div").addClass("d-none");
		  }
	  }
	})
}

$('.ajax_add_to_cart_button').click(function (event) {
	event.preventDefault();        
	var productId = $(this).attr('data-productid');      
	console.log(productId);  	
	var productwrap = $(this).parents('.product-preview');
	var variant_id = $(productwrap).find('.product-actions-' + productId + ' select[name=id]').val();
	if (!variant_id) {
	   variant_id = $(productwrap).find('.product-actions-' + productId + ' input[name=id]').val();
	}
	var quantity = $(productwrap).find('.product-actions-' + productId + ' input[name=quantity]').val();
	if (!quantity) {
		quantity = 1;
	}
	if(variant_id) {
		//var title = $(productwrap).find('.product-title').html();
		//var image = $(productwrap).find('.preview img').attr('src');
		//AjaxAddToCart(variant_id, quantity, title, image);        
		AjaxAddToCart(variant_id, quantity);
	} else {
	  $('#product-actions-btn-' + productId).click();	  
	}
	return false;
});

$('.ajax_hire_button').click(function (event) {
	event.preventDefault();
	
	//click on hire
	var productId = $(this).attr('data-productid');      
	//console.log(productId );
	var productHandle = $(this).attr('data-product-url').match(/\/products\/([a-z0-9\-]+)/)[1];	
	
	var productwrap = $(this).parents('.product-preview');
	//console.log(productwrap);
	//console.log($(productwrap).find('#product-actions-' + productId).val());
	
	var quantity = $(productwrap).find('#product-actions-' + productId).val();
	if (!quantity) {
		quantity = 1;
	}
	//console.log(quantity);
	
	var hireListCookie = [];
	
	var hireListcookieValue = getCookie('shopify_hire_list');
	if (hireListcookieValue !== null) {
		hireListCookie = hireListcookieValue.split(' ');
	}
	
	 // In what position is that product in memory.
	 var position = jQuery.inArray(productHandle, hireListCookie);
	 // If not in memory.
	 if (position === -1) {
	   // Add product at the start of the list.
	   hireListCookie.unshift(productHandle);
	   // Only keep what we need.
	   //hireListCookie = hireListCookie.splice(0, config.howManyToStoreInMemory);
	 }
	 else {
	   // Remove the product and place it at start of list.
	   hireListCookie.splice(position, 1);
	   hireListCookie.unshift(productHandle);              
	 }	 
	 
	 //console.log(hireListCookie.join(' '));
	 
	 // Update cookie.
	 setCookie('shopify_hire_list',hireListCookie.join(' '),3);	
	 
	 //Hire list with count
	 hireListCookieArrayObj = {};
	
	 var hireListcookieObjValue = getCookie('shopify_hire_list_obj');
	 //console.log(hireListcookieObjValue);
	 if (hireListcookieObjValue !== null) {
		 hireListCookieArrayObj = JSON.parse(hireListcookieObjValue);
	 }
	 
	 hireListCookieArrayObj[productHandle] = quantity;
	 	 
	 //console.log(JSON.stringify(hireListCookieArrayObj));
	 setCookie('shopify_hire_list_obj',JSON.stringify(hireListCookieArrayObj),3);	
	 //console.log(getCookie('shopify_hire_list_obj'));

	$(".hire_list_top_count").html("Hire list (" + countHireList() + ")");
});

function countHireList() {
	var countHireListNumber = 0;
	var hireListcookieValue = getCookie('shopify_hire_list');
	if (hireListcookieValue !== null) {
		hireListCookie = hireListcookieValue.split(' ');
		countHireListNumber = hireListCookie.length;
	}
	return countHireListNumber;	
}

function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}